import { useTheme } from '@emotion/react'
import { AppState } from '@news-mono/web-common'
import React from 'react'
import { useSelector } from 'react-redux'
import { themedValue } from '../__styling'
import { MastheadPreference } from './components/MastheadPreference'
import {
    StyledPerthNowLogo,
    StyledTheWestLogo,
} from './components/PreferenceSection.styled'
import { getMastheadPreferences } from './config'
import {
    StyledBody,
    StyledEmail,
    StyledEmailPreference,
    StyledFooter,
    StyledGreeting,
    StyledHeading,
    StyledWebLink,
} from './EmailPreference.styled'
import {
    useEmailPreferenceData,
    useGetEmailToken,
    useGetPreferences,
} from './hooks/useEmailPreferenceData'

export const EmailPreference = () => {
    const theme = useTheme()
    const authState = useSelector((state: AppState) => state.authentication)
    const { userName, userEmail, isLoggedIn } = authState
    const [userFirstName] = isLoggedIn ? userName.split(' ') : ['Please log in']

    const {
        isLoading: isTokenLoading,
        isError: isTokenError,
        data: tokenData,
        error: tokenError,
    } = useGetEmailToken(isLoggedIn)
    const {
        isLoading: isPreferenceLoading,
        isError: isPreferenceError,
        data: preferenceData,
        error: preferenceError,
    } = useEmailPreferenceData(tokenData?.token)

    if (isTokenError) {
        throw new Error(tokenError as string)
    }

    if (isPreferenceError) {
        throw new Error(preferenceError as string)
    }
    const mastheadPreferences = useGetPreferences(
        preferenceData?.result,
        getMastheadPreferences(theme),
    )

    const meta = themedValue(theme, {
        thewest: {
            logoGroup: [<StyledTheWestLogo />, <StyledPerthNowLogo />],
        },
        perthnow: {
            logoGroup: [<StyledPerthNowLogo />, <StyledTheWestLogo />],
        },
        sevennews: {
            logoGroup: [],
        },
    })

    return (
        <StyledEmailPreference>
            <StyledHeading>Email Preferences</StyledHeading>
            <StyledGreeting>Hi, {userFirstName}!</StyledGreeting>
            <StyledEmail>{userEmail ? userEmail : ''}</StyledEmail>
            <StyledBody>
                Pick and choose the news that you want delivered to your inbox.
            </StyledBody>
            {mastheadPreferences.map((preferences, index) => (
                <MastheadPreference
                    preferences={preferences}
                    logo={meta.logoGroup[index]}
                    theme={theme}
                    key={index}
                    isLoading={isTokenLoading || isPreferenceLoading}
                />
            ))}
            <StyledFooter>
                <h2>Looking for something else?</h2>
                <StyledWebLink to={'/contact'}>Contact us</StyledWebLink>
                <StyledWebLink to={'/manage-email-preferences'}>
                    Unsubscribe from all promos and marketing
                </StyledWebLink>
            </StyledFooter>
        </StyledEmailPreference>
    )
}
